import React from "react";

const ujwal_kitchloo = () => {
  return (
    <div>
      <h1>Ujwal Kitchloo</h1>

      <h3>
        <em>Computer Engineering, Batch of 27'</em>
        <br />
        <hr />
      </h3>

      <p>
        <strong>CSI Internship Diaries 2025</strong>
      </p>

      <p>
        <strong>
          What was the criteria for shortlisting candidates in the initial
          stages of the recruitment process
        </strong>
        ?<br />
        The criteria for applying was no backlogs and above 7.5 CGPA and the
        first round was an OA(Online Aptitude) test.
      </p>

      <p>
        <strong>What was the Timeline of the entire Interview Process</strong>?
        <br />
        All the candidates shortlisted after OA were divided into 3 teams, I was
        in LCS team
        <br />
        There were 3 rounds in entire Interview process:
      </p>

      <ul>
        <li>2 Technical Rounds </li>
        <li>HR Round</li>
      </ul>

      <p>
        <strong>What was the Structure of the Aptitude Round?</strong>
        <br />
        The Aptitude Round was conducted online but we were seated in cognizant
        lab. The test was conducted on hackerearth platform and lasted for 1 hr
        20 mins. The test was only MCQ(total 24 in number), no coding questions
        were there, and the MCQ’s were also easy .MCQ’s were related to general
        topics like OOPS, guess the output provided the code, find time
        complexity of code snippet and find errors in the code snippet provided,
        some MCQ’s were also based on general aptitude topics, overall these
        were quite easy to attempt.{" "}
      </p>

      <p>
        <strong>
          How many students were shortlisted after the Aptitude Round?
        </strong>
        <br />
        After the Aptitude Round, 51 students were shortlisted.
      </p>

      <p>
        <strong>
          After being shortlisted, how long was the wait time before the
          interviews began? During this period, what specific areas did you
          focus on to prepare effectively?
        </strong>
        <br />
        OA was scheduled on 29th of September and the interviews were on 30th of
        September itself. During this period, I revised OOPS and DBMS concepts
        and went through my projects thoroughly, also you should not study a new
        concept if there is very less time remaining for the interviews.
        <br />
        <strong>
          How many Interview Rounds were there for the company, can you
          elaborate about each round in brief? Also mention, how many students
          were shortlisted after each Interview Round?
        </strong>
        <br />
        After the OA test, the shortlisted candidates were divided in a team of
        3 and I was in LCS team where around 36 students were there. Only for
        our team there were 2 Technical rounds and an HR round, the other teams
        only had 2 Technical rounds and no HR round.
        <br />
        After the first Technical round, 17 were selected for round 2 and for HR
        round 9 were selected out of which 6 were finally shortlisted from my
        team.
      </p>

      <ul>
        <li>
          First Technical Round: In this round, I was asked a DSA question about
          linked lists, asked to explain projects, and OOPS concepts like
          explain 4 pillars, what is diamond problem, virtual classes. This
          round was totally focused on my projects, specially my MERN project,
          questions like what is React-Router-DOM and why you specifically
          choose Mongoose, why not SQL,what is HTTP and HTTP status codes and
          their meaning was also asked.{" "}
        </li>
        <li>
          Second Technical Round: In this round also I was asked a DSA question
          about arrays, again about my projects(since panels for both rounds
          were different), also some HR questions like what are your interests,
          what is your dream company, would you go for higher studies or not
          like this were asked.{" "}
        </li>
        <li>
          HR round: This was a conversational round, where I was asked to
          introduce myself and questions regarding my family background were
          also asked. Also, I was asked about what Siemens actually is into,
          which Siemens products are you familiar with, etc.{" "}
        </li>
      </ul>

      <p>
        <strong>
          What Topics or Skills did the interviewers focus on during the
          interviews? (e.g., DSA, Puzzles, DBMS, OS, Networks, System Design, or
          Behavioral questions)
        </strong>
        <br />
        During the interview process, DSA was the main focus of interviewers,
        besides this, concepts of OOPS, DBMS and even puzzles were also asked.
        It also depends on your resume if you have mentioned some subjects and
        if the interviewer is having expertise in that ,he might question you on
        that. Along with this, you should have deep knowledge of your projects
        like how you have done it, why you have chosen a particular tech stack,
        be prepared to even code sometimes a part of your project, I was asked
        how to create a stripe instance.{" "}
      </p>

      <p>
        <strong>
          What are some good resources that you used in your Internship Prep?
        </strong>
        <br />
        DSA: Leetcode, GFG for problem solving, Striver’s sheet for DSA
        <br />
        OS: Abhijit sir’s videos, Love babbar
        <br />
        DBMS: Love babbar, Amit Khurrana(if you have time), SQL practice on
        Hackerrank
        <br />
        APTITUDE: IndiaBix for practicing questions
        <br />
        REVISION: GFG short notes on OS, DBMS
        <br />
        PUZZLES: There is a separate GFG section dedicated to this, you can use
        that
      </p>

      <p>
        <strong>Some tips to crack Coding Questions?</strong>
        <br />
        Practice is the only thing which can help you crack coding questions,
        you need to be familiar enough with what concepts can be applied to a
        particular question, that comes when you have practiced enough and you
        need to start as early as possible to be able to crack coding questions
        .When in an interview you are asked a coding question, you should always
        explain your solution, because the interviewer doesn’t expect you to
        provide the most optimal solution instead he wants to see how you
        approach the problem.{" "}
      </p>

      <p>
        <strong>
          How many questions were asked about Projects, Clubs, and
          Extracurricular activities in your resume
        </strong>
        ?<br />I willingly told about my interest in chess and table tennis,
        although I was not directly questioned by the interviewer.
      </p>

      <p>
        <strong>
          Is there something specific that you would want to tell people who are
          preparing for the same company
        </strong>
        ?<br />
        Your behaviour should be that of a learner, you should try to explain to
        the point and explain your projects in a good way, also before going to
        the interview you should know what Siemens is and its background and
        should have a strong hold on the subjects you have mentioned in your
        resume.{" "}
      </p>

      <p>
        <strong>Any Final Tips for Juniors?</strong>
        <br />
        You should start your preparation as soon as possible, always try to
        stay calm and composed during the interview process and try to express
        yourself during the interviews, and remember rejections are a part of
        life, they are beginning of a new chapter, maybe God got some better
        plan for you😁
        <br />
        Wish you the best!!
      </p>

      <p>
        <strong>Contact Info </strong>
        <br />
        <strong>Email :</strong> <a href="mailto:kitchloou23.comp@coeptech.ac.in">kitchloou23.comp@coeptech.ac.in</a>
      </p>
    </div>
  );
};

export default ujwal_kitchloo;
